import { Singleton } from '@visiba/instantiation';
import { PopoverService } from '@routes/appointment/popover.service';

interface AddModalOptions {
	persistent?: boolean;
	overlay?: boolean;
	animations?: boolean;
}

@Singleton()
export class PopoverController {
	constructor(public readonly popoverService: PopoverService) {}

	public addModal(jsx: JSX.Element, options: AddModalOptions = {}): void {
		const mergedOptions = { persistent: false, overlay: true, animations: true, ...options };

		this.shift();
		const modal = this.popoverService.modalStack.createSpecification(
			jsx,
			mergedOptions.persistent,
			mergedOptions.overlay,
			mergedOptions.animations,
		);
		this.popoverService.modalStack.injectSpecification(modal);
	}

	public shift(): void {
		this.popoverService.modalStack.remove();
	}
}
